import { render } from "./studentStatus.vue?vue&type=template&id=2acafe64&scoped=true"
import script from "./studentStatus.vue?vue&type=script&lang=js"
export * from "./studentStatus.vue?vue&type=script&lang=js"

import "./studentStatus.vue?vue&type=style&index=0&id=2acafe64&scoped=true&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-2acafe64"]])

export default __exports__